import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { StaticImage } from "gatsby-plugin-image";


const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 1600 },
        items: 5,
    },
    desktop: {
        breakpoint: { max: 1599, min: 1400 },
        items: 5,
    },
    tabletlandscape: {
        breakpoint: { max: 1399, min: 1200 },
        items: 5,
    },
    tablet: {
        breakpoint: { max: 1199, min: 667 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 666, min: 0 },
        items: 2,
    },
};

function FeatureAR({rtl}) {
    return (
        <div className="feature_sec no_shadow rtl-style">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={3} lg={2} xl={2} xxl={2} className="my-auto">
                        <h4>نحن متميزون في</h4>
                    </Col>
                    <Col xs={12} md={9} lg={10} xl={10} xxl={10} className="my-auto">
                        <Carousel
                            responsive={responsive}
                            infinite={true}
                            autoPlay={true}
                            autoPlaySpeed={3000}
                            arrows={false}
                            rtl={rtl}
                            className="carousel_featured_new carousel_hire_dubai"
                        >
                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/1.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/2.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/3.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/4.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/5.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/1.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/2.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/3.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/4.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="featured_img">
                                    <StaticImage
                                        src="../../../images/locationgcc/hire-dubai/featured/5.webp"
                                        alt="hire_app"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={129}
                                        height={110}
                                    />
                                </div>
                            </div>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default FeatureAR;
